import { render } from "./NumberContainer.vue?vue&type=template&id=0db68a44&scoped=true"
import script from "./NumberContainer.vue?vue&type=script&lang=js"
export * from "./NumberContainer.vue?vue&type=script&lang=js"

import "./NumberContainer.vue?vue&type=style&index=0&id=0db68a44&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0db68a44"]])

export default __exports__